module.exports = __webpack_public_path__ + "static/img/logo-footer.22cd9fdd.png";